<template>
    <b-container fluid class="card p-2">
        <div class="text-center p-4 mb-4 bg-dark">
            <span class="h1 font-weight-bold">
                <i class="fa-solid fa-door-open mr-3"></i>
                INGRESAR DESPACHO
            </span>
            <p class="mt-2">Registrar un nuevo despacho para la Super Transporte.</p>
        </div>

        <b-card class="shadow-sm border-0 bg-dark">
            <b-form @submit.prevent="registrarDespacho">
                <b-row class="mb-4">
                    <b-col cols="12" lg="6">
                        <b-form-group label="ID Despacho Terminal" label-for="idDespachoTerminal">
                            <b-form-input id="idDespachoTerminal" v-model="form.idDespachoTerminal"
                                placeholder="Ej: 24213213" required />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" lg="6">
                        <b-form-group label="Terminal Despacho" label-for="terminalDespacho">
                            <b-form-input id="terminalDespacho" v-model="form.terminalDespacho"
                                placeholder="Ej: Terminal Norte" required />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" lg="6">
                        <b-form-group label="NIT Empresa Transporte" label-for="nitEmpresaTransporte">
                            <b-form-input id="nitEmpresaTransporte" v-model="form.nitEmpresaTransporte"
                                placeholder="Ej: 900123456" required />
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="mb-4">
                    <b-col cols="12" lg="6">
                        <b-form-group label="Razón Social" label-for="razonSocial">
                            <b-form-input id="razonSocial" v-model="form.razonSocial"
                                placeholder="Ej: Transportes Ejemplo S.A.S." required />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" lg="6">
                        <b-form-group label="Número Pasajeros" label-for="numeroPasajero">
                            <b-form-input id="numeroPasajero" v-model="form.numeroPasajero" type="number" min="1"
                                placeholder="Ej: 35" required />
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="mb-4">
                    <b-col cols="12" lg="4">
                        <b-form-group label="Valor Tiquete" label-for="valorTiquete">
                            <b-form-input id="valorTiquete" v-model="form.valorTiquete" type="number" step="0.01"
                                placeholder="Ej: 25000.53" required />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <b-form-group label="Valor Total Tasa Uso" label-for="valorTotalTasaUso">
                            <b-form-input id="valorTotalTasaUso" v-model="form.valorTotalTasaUso" type="number"
                                step="0.01" placeholder="Ej: 1500.25" required />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <b-form-group label="Valor Prueba Alcoholimetría" label-for="valorPruebaAlcoholimetria">
                            <b-form-input id="valorPruebaAlcoholimetria" v-model="form.valorPruebaAlcoholimetria"
                                type="number" step="0.01" placeholder="Ej: 0.78" required />
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="mb-4">
                    <b-col cols="12">
                        <b-form-group label="Observaciones" label-for="observaciones">
                            <b-form-textarea id="observaciones" v-model="form.observaciones"
                                placeholder="Ej: Salida puntual 23" rows="3" required />
                        </b-form-group>
                    </b-col>
                </b-row>

                <div class="d-flex justify-content-end pt-2">
                    <b-button type="submit" variant="primary" size="xl" :disabled="loading" class="btn-submit">
                        <b-spinner v-if="loading" small class="mr-2"></b-spinner>
                        <i v-else class="fa-solid fa-floppy-disk mr-2"></i>
                        {{ loading ? 'Guardando...' : 'Guardar Despacho' }}
                    </b-button>
                </div>
            </b-form>
        </b-card>
    </b-container>
</template>


<script>
export default {
    name: 'FormularioDespacho',
    data() {
        return {
            loading: false,
            form: {
                idDespachoTerminal: null,
                terminalDespacho: '',
                nitEmpresaTransporte: '',
                razonSocial: '',
                numeroPasajero: null,
                valorTiquete: null,
                valorTotalTasaUso: null,
                valorPruebaAlcoholimetria: null,
                observaciones: ''
            }
        }
    },
    props: {
        preCarga: {
            type: Object,
            default: null

        }
    },
    watch: {
        preCarga: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.form = {
                        idDespachoTerminal: val.id_despacho_terminal ?? null,
                        terminalDespacho: val.terminal_despacho ?? '',
                        nitEmpresaTransporte: val.nit_empresa_transporte ?? '',
                        razonSocial: val.razon_social ?? '',
                        numeroPasajero: val.numero_pasajero ?? null,
                        valorTiquete: parseFloat(val.valor_tiquete) || null,
                        valorTotalTasaUso: parseFloat(val.valor_total_tasa_uso) || null,
                        valorPruebaAlcoholimetria: parseFloat(val.valor_prueba_alcoholimetria) || null,
                        observaciones: val.observaciones ?? ''
                    };
                }
            }
        }
    },

    methods: {
        async registrarDespacho() {

            this.loading = true;
            const data = { ...this.form };
            console.log("Formulario enviado:", data, "CrearDespacho");

            this.$emit('submit', data, this.preCarga);
            this.loading = false;

        },
        
    }
}
</script>
